<div class="input-wrapper">
  <label [for]="id" [class]="`${labelDisplay()} input-label`">
    <!-- Display text from [label] input -->
    <span class="label-text">{{ label() }}</span>
    <span class="input-icon-wrapper">
      <input
        #inputElement
        class="input"
        [id]="id"
        [type]="type()"
        [value]="value()"
        [disabled]="isDisabled()"
        [attr.aria-describedby]="ariaId"
        [attr.aria-label]="label() || placeholder()"
        [attr.aria-invalid]="isInvalid()"
        [placeholder]="placeholder()"
        [attr.data-1p-ignore]="preventAutofilling()"
        [attr.data-lpignore]="preventAutofilling()"
        [attr.data-bwignore]="preventAutofilling()"
        (focus)="isDirty.set(true); focused.emit($event)"
        (blur)="onBlur($event)"
        (input)="onInput($event)"
        (keydown.arrowup)="upKeyPressed.emit($event)"
        (keydown.arrowdown)="downKeyPressed.emit($event)"
        (keydown.escape)="escKeyPressed.emit($event)"
      />
      <svg warningIcon aria-hidden="true"></svg>
    </span>
  </label>
  <ng-content select="ui-autocomplete"></ng-content>
</div>

<!-- Character counter display -->
@if (additionalMessage() && !isInvalid()) {
  <p class="character-count" aria-live="polite" aria-atomic="true">
    {{ additionalMessage() }}
  </p>
}

<!-- Error message display when validation fails -->
@if (errorMessage()) {
  <p class="input-error-message" [id]="ariaId" aria-live="polite">
    {{ errorMessage() }}
  </p>
}
